var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { TaxCalculationPhase as TaxCalculationPhaseProto, TaxInclusionType as TaxInclusionTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import { fragment } from 'ember-data-model-fragments/attributes';
const taxCalculationPhaseTypeObject = {};
Object.keys(TaxCalculationPhaseProto).forEach(key => {
  const _key = key;
  taxCalculationPhaseTypeObject[_key] = _key;
});
export const TAX_CALCULATION_PHASE_TYPE = Object.freeze(taxCalculationPhaseTypeObject);
const taxInclusionTypeObject = {};
Object.keys(TaxInclusionTypeProto).forEach(key => {
  const _key = key;
  taxInclusionTypeObject[_key] = _key;
});
export const TAX_INCLUSION_TYPE = Object.freeze(taxInclusionTypeObject);
let Data = (_dec = attr('string'), _dec2 = attr('string', {
  defaultValue: TAX_CALCULATION_PHASE_TYPE.TAX_SUBTOTAL_PHASE
}), _dec3 = attr('string', {
  defaultValue: TAX_INCLUSION_TYPE.ADDITIVE
}), _dec4 = attr('string'), _dec5 = attr('boolean'), _dec6 = attr('boolean'), _dec7 = attr('string'), _dec8 = attr('string'), _dec9 = fragment('price-money'), _dec10 = attr('string'), _class = (_class2 = class Data extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "calculationPhase", _descriptor2, this);
    _initializerDefineProperty(this, "inclusionType", _descriptor3, this);
    _initializerDefineProperty(this, "percentage", _descriptor4, this);
    _initializerDefineProperty(this, "appliesToCustomAmounts", _descriptor5, this);
    _initializerDefineProperty(this, "enabled", _descriptor6, this);
    _initializerDefineProperty(this, "taxTypeId", _descriptor7, this);
    _initializerDefineProperty(this, "taxTypeName", _descriptor8, this);
    _initializerDefineProperty(this, "amount", _descriptor9, this);
    _initializerDefineProperty(this, "appliesToProductSetId", _descriptor10, this);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/tax/data'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "calculationPhase", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "inclusionType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "percentage", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "appliesToCustomAmounts", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "enabled", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "taxTypeId", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "taxTypeName", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "amount", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "appliesToProductSetId", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Data as default };